import React from 'react'
import GamificationBlock from '../../UI-components/GamificationBlock/GamificationBlock'
import { WIDGETS } from '../../core/widgets'
import './MyCollectiblesPage.scss'

const MyCollectiblesPage = () => {
	return (
		<div className="main-content my-collectibles-page">
			<GamificationBlock
				domId={WIDGETS.collectibles.domId}
				url={WIDGETS.collectibles.url}
				fit="content"
				className="gamification-block--content"
			/>
		</div>
	)
}

export default MyCollectiblesPage
